// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDFYUMabJ0Cu9BGPGgulL8rJs06Czoj7zg",
  authDomain: "vision-ui-app.firebaseapp.com",
  projectId: "vision-ui-app",
  storageBucket: "vision-ui-app.firebasestorage.app",
  messagingSenderId: "795520531355",
  appId: "1:795520531355:web:2befbfe9c0a7311e60ff3e",
  measurementId: "G-85DWVPD375"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export { onAuthStateChanged } from "firebase/auth"
